export const SET_TRANSFER_PROTOCOLS = 'SET_TRANSFER_PROTOCOLS';
export const ADD_TRANSFER_PROTOCOL = 'ADD_TRANSFER_PROTOCOL';
export const UPDATE_TRANSFER_PROTOCOL = 'UPDATE_TRANSFER_PROTOCOL';
